import { combineReducers, configureStore } from "@reduxjs/toolkit";
import demoSlice from "./demoReducer";
import messageSlice from "./messageReducer";
import providerSlice from "./providerReducer";
import fhirSlice from "./fhirReducer";
import {
  FLUSH,
  PURGE,
  PAUSE,
  PERSIST,
  REGISTER,
  REHYDRATE,
  persistStore,
  persistReducer,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const rootReducer = combineReducers({
  demoReducer: demoSlice,
  messages: messageSlice,
  provider: providerSlice,
  fhir: fhirSlice,
});

const persistConfig: any = {
  key: "root",
  version: 1,
  storage: storage,
  whitelist: ["provider"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

let persistor = persistStore(store);
export { store, persistor };
